import { useLoadPayPalSDK } from '../useLoadPaypalJs';
import useCheckDevice from '../useCheckDevice';
import { useEffect, useState, useMemo } from 'react';
import { UsePayPalScriptLoaderProps } from './types';

export const usePayPalScriptLoader = ({
  isPayPalAvailable = false,
  lazyLoad = true,
}: UsePayPalScriptLoaderProps = {}) => {
  const { loadPayPalScript } = useLoadPayPalSDK(isPayPalAvailable);
  const [firstScroll, setFirstScroll] = useState(false);
  const { mobileCheck } = useCheckDevice();

  const isMobile = useMemo(() => mobileCheck(), [mobileCheck]);

  const handleLoadPaypalSDK = () => {
    setFirstScroll(true);
    loadPayPalScript();
  };

  useEffect(() => {
    if (!isPayPalAvailable) {
      return;
    }

    if (!lazyLoad) {
      return handleLoadPaypalSDK();
    }

    if (!isMobile) {
      return handleLoadPaypalSDK();
    }

    if (firstScroll) {
      window.removeEventListener('scroll', handleLoadPaypalSDK);
      return;
    }

    if (isMobile) {
      window.addEventListener('scroll', handleLoadPaypalSDK);
    }

    return () => {
      window.removeEventListener('scroll', handleLoadPaypalSDK);
    };
  }, [firstScroll, isMobile, isPayPalAvailable, lazyLoad]);

  return {
    isMobile,
    isFirstLoad: firstScroll,
  };
};

export default usePayPalScriptLoader;
